import React, { useState, useEffect } from 'react';
import API from '../../../Services/BaseService';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import "../../../Component/CommonPopup/commonPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
import Loading from "../../../Component/Loading/Loading";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ViewBuyerNotesPopup = (props) => {

    const history = useHistory();
    const [loading, setloading] = useState(true);

    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    const [comments, setComments] = useState(props.notesName);
    const [commentsError, setCommentsError] = useState("");
    const adminData = useSelector(state => state.LoginReducer.payload);
    const [togglePopupOpen, setTogglePopupOpen] = useState(true);
    const [buyerNotes, setBuyerNotes] = useState("");

    const toggleCommonPopup = () => {
        setIsCommonPopupOpen(!isCommonPopupOpen);
    }
    useEffect(() => {

        getBuyerNotes();

    }, [])
    const getBuyerNotes = () => {

        let request = {

            buyer_notes_id: props.notesId,

        }
        console.log("=====request", request)

        API.post("buyernotes_view/condition", request).then(response => {

        });
    }

    useEffect(() => {

        getBuyerDetails();

    }, [])

    const getBuyerDetails = () => {
        let request = {

            bill_of_sale_id: props.bosId,

        }
        API.post("buyernotes_list/condition", request).then(response => {
            setBuyerNotes(response.data?.data)
            setloading(false);

        });
    }

    return (
        <>

            <Modal show={true} onHide={props.toggle} centered>
                <Modal.Header className="Terms-login">
                    <Modal.Title>Buyer Notes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <Loading /> :
                        <>
                            <div className="table-box sellernotes-sec">
                                <div className="table-responsive fixTableHead">
                                    <table className="table">

                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>User</th>
                                                <th>Location</th>
                                                <th>Notes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {buyerNotes?.length > 0 ? buyerNotes?.map((buyerNote, index) =>
                                                <tr key={index}>
                                                    <td>{buyerNote.date}</td>
                                                    <td>{buyerNote.dealer_name}</td>
                                                    <td>{buyerNote.location}</td>
                                                    <td>{buyerNote.buyer_notes}</td>
                                                </tr>
                                            ) : <tr><td colSpan="5" className='text-center'><p>No Data Found</p></td></tr>}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="Sellernotes">
                                <Button className="cta-btn" onClick={props.toggle}>Close</Button>
                            </div>
                        </>
                    }
                </Modal.Body>
            </Modal>
            {isCommonPopupOpen && <CommonPopup
                handleClose={isCommonPopupOpen}
                popupTitle={popupTitle}
                popupMsg={popupMsg}
                popupType={popupType}
                popupActionType={popupActionType}
                popupActionValue={popupActionValue}
                popupActionPath={popupActionPath}
            />}


        </>
    )
}

export default ViewBuyerNotesPopup;